import { FC, useCallback, useEffect, useRef, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { twMerge } from 'tailwind-merge';

type IProps = {
  className?: string;
  innerCls?: string;
  // 滚动元素之间的距离
  space?: number;
  text: string;
  // 偏移距离，单位px
  step?: number;
  // 偏移所用时间,单位耗秒
  duration?: number;
};

const TextMarquee: FC<IProps> = props => {
  const { className, innerCls, text, space = 30, duration = 20, step = 4 } = props;

  const [marquee, setMarquee] = useState(false);

  const { ref, inView } = useInView();
  // 容器元素
  const containRef = useRef<HTMLDivElement>(null);
  // 内容元素
  const innerRef = useRef<HTMLDivElement>(null);
  const animationRef = useRef<number | null>(null);
  const offsetRef = useRef(0);

  const animation = useCallback(() => {
    if (!inView || !innerRef.current) {
      if (animationRef.current !== null) {
        cancelAnimationFrame(animationRef.current);
      }
      return '';
    }
    const firstChild = innerRef.current.firstElementChild as HTMLDivElement | null;
    if (!firstChild) return '';
    const childtWidth = firstChild.offsetWidth;
    if (!childtWidth) return '';
    const offset = offsetRef.current;
    // 滚动距离
    const instance = childtWidth * 1.5;
    if (offset > instance) {
      offsetRef.current = offset - childtWidth;
    } else {
      offsetRef.current = offset + step / duration;
    }
    innerRef.current.style.transform = `translateX(-${offsetRef.current}px)`;
    animationRef.current = requestAnimationFrame(animation);
  }, [duration, inView, step]);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | null = null;
    if (containRef.current && innerRef.current) {
      timer = setTimeout(() => {
        if (!containRef.current || !innerRef.current) return;
        const containRect = containRef.current.getBoundingClientRect();
        const innerRect = innerRef.current.getBoundingClientRect();
        const containWidth = containRect?.width || 0;
        const innerWidth = innerRect?.width || 0;
        if (innerWidth <= containWidth) return;
        setMarquee(true);
        animation();
      }, 300);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
      if (animationRef.current !== null) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [animation, inView, text]);

  if (!text) return null;

  return (
    <div ref={containRef} className={twMerge('w-full whitespace-nowrap', className)}>
      <div ref={ref}></div>
      <div className="inline-flex items-center" ref={innerRef}>
        {marquee ? (
          <>
            {new Array(3).fill(text).map((item, index) => {
              return (
                <span
                  key={`inner-${index}`}
                  className={twMerge('inline-block', innerCls)}
                  dangerouslySetInnerHTML={{ __html: item }}
                  style={{ paddingRight: space }}></span>
              );
            })}
          </>
        ) : (
          <span className={innerCls} dangerouslySetInnerHTML={{ __html: text }}></span>
        )}
      </div>
    </div>
  );
};

export default TextMarquee;
